<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    this.isMobile();
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag === null) {
        
      } else {
        window.location.href=window.vueConfig.info.mobildHref;
      }
    }
  }
};
</script>
<style>
.dataNone{
  width: 100%;
  font-size: 14px;
  text-align: center;
  padding: 40px 0;
  color: #CCC;
}
a {
  text-decoration: none;
  color: #fff;
}
a:hover,
a:visited,
a:link,
a:active {
  color: #fff;
}
#app {
  /* max-width: 1920px; */
  margin: auto;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  margin: auto;
  padding: 0;
  margin: auto;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue